import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetPlaintiffsFirms = () => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-plaintiffs-firms'],
        queryFn: async () => {
            const response = await zoneApiClient.getZoneSpecificLookupData(LookupDataEnums.PlaintiffsFirms);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve plaintiffs firms.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
